exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2pp55y0M1MemwwyS6yMIl5{width:110px}\n", ""]);
// Exports
exports.locals = {
	"logo": "_2pp55y0M1MemwwyS6yMIl5"
};